<script lang="ts" setup>
import type { SectionsButtonActions } from '@autobid/strapi-integration/rest/components'
import { buttonActions } from '@autobid/ui/utils/cva/buttonActionsCva'
import { computed } from 'vue'

interface Props {
  data: SectionsButtonActions
}

const props = defineProps<Props>()

const visibleButtons = computed(() =>
  props.data.buttons?.filter(el => el && !el.hidden) || [],
)
</script>

<template>
  <div v-if="visibleButtons.length" class="px-3 xl:pl-0">
    <p
      v-if="data.title"
      class="font-bold" :class="[
        buttonActions({
          alignedContent: data.alignedContent?.name,
        }),
      ]"
    >
      {{ data.title }}
    </p>

    <div
      class="buttons-actions flex flex-wrap items-center gap-1"
      :class="
        buttonActions({
          layout: data.layout,
          alignedButtons: data.alignedContent?.name,
        })
      "
    >
      <!-- @vue-skip - color in the strapi is an enum but the components accepts string in fact -->
      <elements-button
        v-for="button in visibleButtons"
        :key="button.url"
        v-bind="button"
      >
        {{ button.text }}
      </elements-button>
    </div>
  </div>
</template>
